"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexUserRequests = void 0;
const Paths_1 = require("../Paths");
const Utils_1 = require("../Utils");
const IndexUtils_1 = require("./IndexUtils");
const helpers_1 = require("./IndexUtils/helpers");
const OptionsHandler_1 = require("./IndexUtils/OptionsHandler");
class IndexUserRequests {
    constructor(session, appInfo) {
        this.session = session;
        this.appInfo = appInfo;
        this.deakoOptions = new OptionsHandler_1.OptionsHandler(this.appInfo);
    }
    getIdent() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = {
                method: Paths_1.Methods.GET,
            };
            const requestBuilt = yield (0, Utils_1.buildGenericRequest)(this.session, request, this.deakoOptions);
            const endpoint = (0, IndexUtils_1.getIdentEndpoint)();
            const resp = yield (0, Utils_1.wrapFetchJson)(requestBuilt, endpoint);
            return (0, IndexUtils_1.cleanIdent)(resp.ident);
        });
    }
    getProfilesByUserSub(userSub) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = {
                method: Paths_1.Methods.GET,
            };
            const requestBuilt = yield (0, Utils_1.buildGenericRequest)(this.session, request, this.deakoOptions);
            const endpoint = (0, IndexUtils_1.getSpecificUserTaskEndpoint)(this.session, userSub);
            const response = yield (0, Utils_1.wrapFetchJson)(requestBuilt, endpoint);
            return (0, helpers_1.mapIndexToProfileList)((0, IndexUtils_1.cleanIndexWrapper)(response));
        });
    }
    getAllProfiles() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = {
                method: Paths_1.Methods.GET,
            };
            const rawIndexProfile = yield this.makeRequest({ request });
            return (0, IndexUtils_1.cleanIndexWrapper)(rawIndexProfile);
        });
    }
    setProfileFor3rdPartyIntegration(integration, env, profileUuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = {
                method: Paths_1.Methods.POST,
                body: {
                    type: Paths_1.TaskTypes.EDIT_USER_V1,
                    argument: {
                        properties: {
                            integrations: {
                                [integration]: Paths_1.UuidPrefixes.profileId + profileUuid,
                            },
                            env,
                        },
                    },
                },
            };
            return this.makeRequest({
                request,
                isTask: true,
            });
        });
    }
    editUser(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const { name, phone, textOptIn } = opts;
            const editUserNameRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    argument: {
                        properties: {
                            name,
                            phone,
                            textOptIn,
                        },
                    },
                    type: Paths_1.TaskTypes.EDIT_USER_V1,
                },
            };
            return this.makeRequest({
                request: editUserNameRequest,
                isTask: true,
            });
        });
    }
    deleteUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const deleteUserRequest = {
                method: Paths_1.Methods.DELETE,
            };
            return this.makeRequest({
                request: deleteUserRequest,
                isTask: false,
            });
        });
    }
    editUserTOS(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const { signedAt, signedVersion } = opts;
            const editUserTOSRequest = {
                method: Paths_1.Methods.POST,
                body: {
                    argument: {
                        properties: {
                            tos: {
                                signedAt: signedAt.toISOString(),
                                signedVersion,
                            },
                        },
                    },
                    type: Paths_1.TaskTypes.EDIT_USER_V1,
                },
            };
            return this.makeRequest({
                request: editUserTOSRequest,
                isTask: true,
            });
        });
    }
    makeRequest(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const { request, isTask } = opts;
            const requestBuilt = yield (0, Utils_1.buildGenericRequest)(this.session, request, this.deakoOptions);
            const endpoint = (0, IndexUtils_1.getUserTaskEndpoint)(this.session, !!isTask);
            return (0, Utils_1.wrapFetchJson)(requestBuilt, endpoint);
        });
    }
}
exports.IndexUserRequests = IndexUserRequests;
//# sourceMappingURL=IndexUserRequests.js.map